module.exports = __webpack_public_path__ + "static/img/rank_37.c7f4149.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_37.png
// module id = KOl6
// module chunks = 0